module.exports = __webpack_public_path__ + "static/media/2022_2A3A1594.c47a28f1.jpg";